import {LotoCardboard} from "../entities/LotoCardboard";

export const isValidNumber = (n: string) => {
    const num = Number(n);
    return Number.isInteger(num) && num >= 1 && num <= 90;
};

export const validateLotoCardboardNumbers = (numbers: string[]): { valid: boolean; errors: string[] } => {
    const errors: string[] = [];
    const unique = new Set(numbers);
    if (unique.size !== numbers.length) errors.push("Des doublons sont présents");
    if (numbers.some((n) => !isValidNumber(n))) errors.push("Numéros hors plage 1..90");
    if (numbers.length !== 15) errors.push("Un carton doit contenir 15 numéros");
    return {valid: errors.length === 0, errors};
};

export const normalizeRows = (lotoCardboard: LotoCardboard): string[][] => {
    if (lotoCardboard.rows && lotoCardboard.rows.length) return lotoCardboard.rows;
    const rows: string[][] = [];
    for (let i = 0; i < 3; i++) rows.push(lotoCardboard.numbers.slice(i * 5, i * 5 + 5));
    return rows;
};
